import {
  AptPriceCompareType,
  ChartSize,
  ChartType,
  CompareType,
  ConfigType,
  DashType,
  DateTypes,
  DatesRangeType,
  LineThicknessType,
  MoveInAnalyzeType,
  PyeongType,
  RankType,
  DataRanges,
  SaleType,
  GroupTypes,
  ValueType,
  DataTypes,
} from "./configs";
import { getMonthInLong, getWeekInLong } from "./date";
import { FaChartLine, FaChartBar, FaChartArea } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import { AiOutlineSmallDash } from "react-icons/ai";
import { RxBorderDashed } from "react-icons/rx";
import { BsDashLg } from "react-icons/bs";
import { CiTextAlignLeft, CiTextAlignRight } from "react-icons/ci";
import { LuEye, LuEyeOff } from "react-icons/lu";

import { TbAlignBoxCenterMiddle } from "react-icons/tb";
import { TbAlignBoxCenterBottom } from "react-icons/tb";
import { TbAlignBoxCenterTop } from "react-icons/tb";
import { AptSortKeys } from "src/configs/sort-keys";
import { MdLineStyle } from "react-icons/md";

export const createIconOptions = ({ defaultValue, defaultIcon, options }) => {
  const obj = {
    default: defaultValue,
    icon: defaultIcon,
    options,
  };

  obj.getIcon = (value) =>
    obj.options.find((opt) => opt.value === value)?.icon || obj.icon;

  obj.getOption = (value) =>
    obj.options.find((opt) => opt.value === value) || null;

  return obj;
};

export const GroupTypeOptions = {
  default: GroupTypes.SERIES,
  options: [
    {
      label: "그래프",
      value: GroupTypes.SERIES,
    },
    {
      label: "지도",
      value: GroupTypes.MAP,
    },
  ],
};

export const StrokeWidthOptions = {
  default: 1,
  options: [
    {
      label: "없음",
      value: 0,
    },
    {
      label: "1px",
      value: 1,
    },
    {
      label: "2px",
      value: 2,
    },
    {
      label: "3px",
      value: 3,
    },
    {
      label: "4px",
      value: 4,
    },
    {
      label: "8px",
      value: 8,
    },
    {
      label: "12px",
      value: 12,
    },
  ],
};

export const LineHeightOptions = {
  default: 1,
  options: [
    {
      label: "0.5",
      value: 0.5,
    },
    {
      label: "0.75",
      value: 0.75,
    },
    {
      label: "한줄",
      value: 1,
    },
    {
      label: "1.15",
      value: 1.15,
    },
    {
      label: "1.5",
      value: 1.5,
    },
    {
      label: "두줄",
      value: 2,
    },
  ],
};

export const TextSizeOptions = {
  default: 14,
  options: [
    {
      label: "8px",
      value: 8,
    },
    {
      label: "10px",
      value: 10,
    },
    {
      label: "14px",
      value: 14,
    },
    {
      label: "16px",
      value: 16,
    },
    {
      label: "20px",
      value: 20,
    },
    {
      label: "24px",
      value: 24,
    },
  ],
};

export const PriceAnalyzePeriodOptions = {
  default: 2,
  options: [
    {
      label: "2주",
      value: 2,
    },
    {
      label: "1개월",
      value: 10,
    },
    {
      label: "3개월",
      value: 30,
    },
    {
      label: "6개월",
      value: 60,
    },
    {
      label: "1년",
      value: 100,
    },
  ],
};

export const PyeongOptions = {
  default: 30,
  options: [
    {
      label: "10평",
      value: 10,
    },
    {
      label: "20평",
      value: 20,
    },
    {
      label: "30평",
      value: 30,
    },
    {
      label: "40평",
      value: 40,
    },
    {
      label: "50평",
      value: 50,
    },
    {
      label: "60평",
      value: 60,
    },
    {
      label: "70평",
      value: 70,
    },
  ],
};

export const UnsoldGraphOptions = {
  default: ChartType.AREA,
  options: [
    {
      label: "막대",
      value: ChartType.COLUMN,
      icon: <FaChartBar />,
    },
    {
      label: "범위",
      value: ChartType.AREA,
      icon: <FaChartArea />,
    },
  ],
};

export const MoveInAnalyzeOptions = {
  default: MoveInAnalyzeType.COMPARE_GUNGU,
  options: [
    {
      label: "지수비교",
      value: MoveInAnalyzeType.COMPARE_INDEX,
    },
    {
      label: "군구분포",
      value: MoveInAnalyzeType.COMPARE_GUNGU,
    },
    {
      label: "APT분포",
      value: MoveInAnalyzeType.COMPARE_APT,
    },
  ],
};

export const AptPriceCompareOptions = {
  default: AptPriceCompareType.DEAL_LEASE,
  options: [
    {
      label: "매전시세",
      value: AptPriceCompareType.DEAL_LEASE,
    },
    {
      label: "평단가",
      value: AptPriceCompareType.PRICE_PER_PYEONG,
    },
    {
      label: "전세가율",
      value: AptPriceCompareType.LEASE_PRICE_RATE,
    },
  ],
};

export const ChartSizeOptions = {
  default: ChartSize.LARGE,
  options: [
    {
      label: "작게",
      value: ChartSize.SMALL,
    },
    {
      label: "중간",
      value: ChartSize.MEDIUM,
    },
    {
      label: "크게",
      value: ChartSize.LARGE,
    },
  ],
};

export const getChartSize = (option) => {
  switch (option) {
    case ChartSize.SMALL:
      return 300;
    case ChartSize.MEDIUM:
      return 500;
    case ChartSize.LARGE:
    default:
      return 700;
  }
};

export const CompareOptions = {
  default: CompareType.COMPARE,
  options: [
    {
      label: "비교분석",
      value: CompareType.COMPARE,
    },
    {
      label: "개별분석",
      value: CompareType.INDIVIDUAL,
    },
  ],
};

export const DatesRangeOptions = {
  default: DatesRangeType.COMPARE,
  options: [
    {
      label: "전주대비",
      value: DatesRangeType.COMPARE,
    },
    {
      label: "증감누적",
      value: DatesRangeType.ACCUMULATE,
    },
  ],
};

export const RankOptions = {
  default: RankType.PRICE_INDEX,
  options: [
    {
      label: "지수",
      value: RankType.PRICE_INDEX,
    },
    {
      label: "매물시세",
      value: RankType.MARKET_PRICE,
    },
    {
      label: "거래량",
      value: RankType.REAL_PRICE,
    },
    {
      label: "매물수",
      value: RankType.SALE_COUNT,
    },
  ],
};

/** 시장현황(월간현황) 전용 — 지수/거래량/매물수/입주물량/미분양 */
export const MonthlyRankOptions = {
  default: RankType.PRICE_INDEX,
  options: [
    { label: "지수", value: RankType.PRICE_INDEX },
    { label: "거래량", value: RankType.REAL_PRICE },
    { label: "매물수", value: RankType.SALE_COUNT },
    { label: "입주물량", value: RankType.MOVE_IN },
    { label: "미분양", value: RankType.UNSOLD },
  ],
};

export const MovingOptions = {
  default: null,
  options: [
    {
      label: "이동평균",
      value: ConfigType.MOVING,
    },
  ],
};

export const MapDataNamesOptions = {
  default: ["dp"],
  options: [
    {
      label: "매매시세",
      value: "dp",
      property: "dealPriceAvr",
      magnification: 10000,
    },
    {
      label: "전세시세",
      value: "lp",
      property: "leasePriceAvr",
      magnification: 10000,
    },
    {
      label: "매매실거래",
      value: "drp",
      property: "dealRealPriceAvr",
      magnification: 10000,
    },
    {
      label: "전세실거래",
      value: "lrp",
      property: "leaseRealPriceAvr",
      magnification: 10000,
    },
    {
      label: "매매시세실거래갭",
      help: "지도에 표시된 매매시세 − 매매실거래입니다.\n양수는 매물시세가 실거래보다 높고, 음수는 낮다는 뜻입니다. 두 값 중 하나라도 없으면 표시하지 않습니다.",
      value: "drpg",
      magnification: 10000,
    },
    {
      label: "전세시세실거래갭",
      help: "지도에 표시된 전세시세 − 전세실거래입니다.\n양수는 매물시세가 실거래보다 높고, 음수는 낮다는 뜻입니다. 두 값 중 하나라도 없으면 표시하지 않습니다.",
      value: "lrpg",
      magnification: 10000,
    },
    {
      label: "매매평당가",
      value: "dppp",
      property: "dealPricePerSpaceAvr",
      magnification: 10000,
    },
    {
      label: "전세평당가",
      value: "lppp",
      property: "leasePricePerSpaceAvr",
      magnification: 10000,
    },
    {
      label: "매매매물수",
      value: "dsc",
      property: "dealCount",
      // reversed: true,
    },
    {
      label: "전세매물수",
      value: "lsc",
      property: "leaseCount",
      // reversed: true,
    },
    {
      label: "월세매물수",
      value: "rsc",
      property: "rentCount",
      // reversed: true,
    },
    {
      label: "인구수",
      value: "pd",
      property: "population",
    },
    {
      label: "세대수",
      value: "hd",
      property: "household",
    },
    {
      label: "전세가율",
      value: "lr",
      property: "leasePriceRateAvr",
    },
    {
      label: "매전갭",
      value: "ldg",
      property: "dealLeaseGapAvr",
      magnification: 10000,
      // reversed: true,
    },
    {
      label: "신고가",
      value: "nhc",
      property: "newHighCount",
      suffix: "건",
      help:
        "해당 지역에서 최근 실거래가가 이전 최고가를 갱신한 공급평형 수입니다.",
    },
    /* Temporarily hidden from map selectors.
    {
      label: "급매",
      value: "bgc",
      property: "bargainCount",
      suffix: "건",
      help:
        "해당 지역에서 최신 정상 최저호가가 직전 90일 정상 최저호가보다 낮아 급매 신호로 판정된 공급평형 수입니다.",
    }, */
    {
      label: "저평가",
      value: "uvc",
      property: "undervalueCount",
      suffix: "건",
      help:
        "해당 지역에서 비교 단지와의 실거래 가격 관계상 저평가 신호로 판정된 공급평형 수입니다.",
    },
  ],
};

/** 공급평형 분석 CInfo를 지도 마커에서 직접 비교하기 위한 아파트 전용 항목이다. */
const AptAnalysisMapDataNameOptions = [
  {
    label: "가격저평가",
    value: "pui",
    property: "undervalueIndex",
    help:
      "비교 아파트들의 실거래 가격 관계를 기준으로 계산한 상대적 저평가 지수입니다. 100이 기준이며 값이 클수록 저평가 신호가 강합니다.",
  },
  {
    label: "평형저평가",
    value: "sui",
    property: "sizeUndervalueIndex",
    help:
      "같은 아파트의 다른 공급평형과 비교한 상대적 저평가 지수입니다. 100이 기준이며 값이 클수록 저평가 신호가 강합니다.",
  },
  /* Temporarily hidden from map selectors.
  {
    label: "급매",
    value: "bgi",
    property: "bargainIndex",
    help:
      "해당 공급평형의 최근 정상 최저호가 흐름과 비교한 급매 지수입니다. 100이 기준이며 값이 클수록 급매 신호가 강합니다.",
  }, */
];

/**
 * 아파트 마커만 표시하는 지도에서 사용하는 데이터 항목이다.
 * 인구수와 세대수는 지역 CInfo 지표이므로 아파트 전용 지도 선택지에서는 제외한다.
 */
export const AptMapDataNamesOptions = {
  default: MapDataNamesOptions.default,
  options: MapDataNamesOptions.options.flatMap((option) => {
    if (["pd", "hd", "nhc", "bgc", "uvc"].includes(option.value)) return [];
    // 가격 정보 흐름을 이어서 읽을 수 있도록 매전갭 바로 뒤에 분석 지수를 둔다.
    return option.value === "ldg"
      ? [option, ...AptAnalysisMapDataNameOptions]
      : [option];
  }),
};

// value → option 전체를 매핑
const MapDataNamesOptionMap = new Map(
  [...MapDataNamesOptions.options, ...AptAnalysisMapDataNameOptions].map((o) => [o.value, o]),
);
export const getMapDataProperty = (value) => {
  return MapDataNamesOptionMap.get(value)?.property ?? null;
};
export const getMapDataMagnification = (value) => {
  return MapDataNamesOptionMap.get(value)?.magnification ?? 1;
};
export const getMapDataLabel = (value) => {
  return MapDataNamesOptionMap.get(value)?.label ?? "";
};
export const getMapDataReversed = (value) => {
  return MapDataNamesOptionMap.get(value)?.reversed ?? false;
};
export const getMapDataSuffix = (value) => {
  return MapDataNamesOptionMap.get(value)?.suffix ?? "";
};

export const MapValueTypeOptions = {
  default: ValueType.VALUE,
  options: [
    {
      label: "최신값",
      value: ValueType.VALUE,
      icon: <CiTextAlignLeft />,
    },
    {
      label: "증감",
      value: ValueType.INDE,
      icon: <CiTextAlignLeft />,
    },
    {
      label: "증감율",
      value: ValueType.INDERATE,
      icon: <CiTextAlignRight />,
    },
  ],
};

export const InDeOptions = {
  default: null,
  options: [
    {
      label: "증감",
      value: ConfigType.INDE,
      icon: <CiTextAlignLeft />,
    },
    {
      label: "증감율",
      value: ConfigType.INDERATE,
      icon: <CiTextAlignRight />,
    },
  ],
};

export const LeftRightOptions = createIconOptions({
  default: ConfigType.LEFT,
  icon: <CiTextAlignLeft />,
  options: [
    {
      label: "왼쪽",
      value: ConfigType.LEFT,
      icon: <CiTextAlignLeft />,
    },
    {
      label: "오른쪽",
      value: ConfigType.RIGHT,
      icon: <CiTextAlignRight />,
    },
  ],
});

export const VisibleOptions = createIconOptions({
  default: ConfigType.ENABLE,
  icon: <LuEye />,
  options: [
    {
      label: "보기",
      value: ConfigType.ENABLE,
      icon: <LuEye />,
    },
    {
      label: "가리기",
      value: ConfigType.DISABLE,
      icon: <LuEyeOff />,
    },
  ],
});

export const TablePositionOptions = {
  default: "tp",
  options: [
    {
      label: "상단",
      value: "tp",
      icon: <TbAlignBoxCenterTop />,
    },
    {
      label: "중간",
      value: "md",
      icon: <TbAlignBoxCenterMiddle />,
    },
    {
      label: "하단",
      value: "bt",
      icon: <TbAlignBoxCenterBottom />,
    },
  ],
};

export const BoxDashTypeOptions = createIconOptions({
  default: "solid",
  icon: <MdLineStyle />,
  options: [
    {
      label: "선",
      value: "solid",
      icon: <BsDashLg />,
    },
    {
      label: "대시",
      value: "dashed",
      icon: <RxBorderDashed />,
    },
    {
      label: "점",
      value: "dotted",
      icon: <AiOutlineSmallDash />,
    },
  ],
});

export const ChartTypeOptions = createIconOptions({
  default: ChartType.LINE,
  icon: <FaChartLine />,
  options: [
    {
      label: "선",
      value: ChartType.LINE,
      icon: <FaChartLine />,
    },
    {
      label: "막대",
      value: ChartType.COLUMN,
      icon: <FaChartBar />,
    },
    {
      label: "범위",
      value: ChartType.AREA,
      icon: <FaChartArea />,
    },
  ],
});

export const DashTypeOptions = createIconOptions({
  default: DashType.SOLID,
  icon: <BsDashLg />,
  options: [
    {
      label: "선",
      value: DashType.SOLID,
      icon: <BsDashLg />,
    },
    {
      label: "대시",
      value: DashType.DASH,
      icon: <RxBorderDashed />,
    },
    {
      label: "점",
      value: DashType.DOT,
      icon: <AiOutlineSmallDash />,
    },
  ],
});

export const LineThicknessOptions = createIconOptions({
  default: LineThicknessType.ONE,
  icon: <FaMinus style={{ fontSize: "8px" }} />,
  options: [
    {
      label: "얇음",
      value: LineThicknessType.ONE,
      icon: <FaMinus style={{ fontSize: "8px" }} />,
    },
    {
      label: "중간",
      value: LineThicknessType.TWO,
      icon: <FaMinus style={{ fontSize: "12px" }} />,
    },
    {
      label: "두꺼움",
      value: LineThicknessType.THREE,
      icon: <FaMinus style={{ fontSize: "16px" }} />,
    },
  ],
});

export const AnalyzeTypeOptions = {
  default: DataRanges.SIDO,
  options: [
    {
      label: "경제",
      value: DataRanges.ECONOMY,
    },

    {
      label: "시도",
      value: DataRanges.SIDO,
    },
    {
      label: "군구",
      value: DataRanges.GUNGU,
    },
  ],
};

export const SidoGroupOptions = {
  default: ConfigType.GROUP,
  options: [
    {
      label: "통합",
      value: ConfigType.TOTAL,
    },
    {
      label: "그룹",
      value: ConfigType.GROUP,
    },
  ],
};

export const DLOptions = {
  default: DataTypes.DEAL,
  options: [
    {
      label: "매매",
      value: DataTypes.DEAL,
    },
    {
      label: "전세",
      value: DataTypes.LEASE,
    },
  ],
};

export const TDLROptions = {
  default: SaleType.TOTAL,
  options: [
    {
      label: "전체",
      value: SaleType.TOTAL,
    },
    {
      label: "매매",
      value: SaleType.DEAL,
    },
    {
      label: "전세",
      value: SaleType.LEASE,
    },
    {
      label: "월세",
      value: SaleType.RENT,
    },
  ],
};

export const DLROptions = {
  default: SaleType.DEAL,
  options: [
    {
      label: "매매",
      value: SaleType.DEAL,
    },
    {
      label: "전세",
      value: SaleType.LEASE,
    },
    {
      label: "월세",
      value: SaleType.RENT,
    },
  ],
};

export const YMOptions = {
  default: DateTypes.MONTHLY,
  options: [
    {
      label: "월간",
      value: DateTypes.MONTHLY,
    },
    {
      label: "년간",
      value: DateTypes.YEARLY,
    },
  ],
};

export const MWOptions = {
  default: DateTypes.MONTHLY,
  options: [
    {
      label: "월간",
      value: DateTypes.MONTHLY,
    },
    {
      label: "주간",
      value: DateTypes.WEEKLY,
    },
  ],
};

export const IndivToggleOptions = {
  default: ConfigType.INDIVIDUAL,
  options: [
    {
      label: "개별",
      value: ConfigType.INDIVIDUAL,
    },
    {
      label: "통합",
      value: ConfigType.UNION,
    },
  ],
};

export const LabelToggleOptions = {
  default: ConfigType.ENABLE,
  options: [
    {
      label: "라벨표시",
      value: ConfigType.ENABLE,
    },
    {
      label: "라벨숨김",
      value: ConfigType.DISABLE,
    },
  ],
};

export const UCToggleOptions = {
  default: SaleType.NORMAL,
  options: [
    {
      label: "전체",
      value: SaleType.TOTAL,
    },
    {
      label: "미분양",
      value: SaleType.NORMAL,
    },
    {
      label: "준공후",
      value: SaleType.AFTER,
    },
  ],
};

export const PyeongsOptions = {
  default: 30,
  options: [
    {
      label: "10평대",
      value: 10,
    },
    {
      label: "20평대",
      value: 20,
    },
    {
      label: "30평대",
      value: 30,
    },
    {
      label: "40평대",
      value: 40,
    },
    {
      label: "50평대",
      value: 50,
    },
    {
      label: "60평대",
      value: 60,
    },
    {
      label: "70평대",
      value: 70,
    },
  ],
};

export const PyeongToOptions = {
  default: 10000,
  options: [
    {
      label: "전체",
      value: 10000,
    },
    {
      label: "70평",
      value: 70,
    },
    {
      label: "60평",
      value: 60,
    },
    {
      label: "50평",
      value: 50,
    },
    {
      label: "40평",
      value: 40,
    },
    {
      label: "30평",
      value: 30,
    },
    {
      label: "20평",
      value: 20,
    },
    {
      label: "10평",
      value: 10,
    },
  ],
};

export const PyeongFromOptions = {
  default: 0,
  options: [
    {
      label: "70평",
      value: 70,
    },
    {
      label: "60평",
      value: 60,
    },
    {
      label: "50평",
      value: 50,
    },
    {
      label: "40평",
      value: 40,
    },
    {
      label: "30평",
      value: 30,
    },
    {
      label: "20평",
      value: 20,
    },
    {
      label: "10평",
      value: 10,
    },
    {
      label: "전체",
      value: 0,
    },
  ],
};

export const AptFromOptions = {
  default: 200,
  options: [
    {
      label: "전체",
      value: 200,
    },
    {
      label: "40년",
      value: 40,
    },
    {
      label: "30년",
      value: 30,
    },
    {
      label: "25년",
      value: 25,
    },
    {
      label: "20년",
      value: 20,
    },
    {
      label: "15년",
      value: 15,
    },
    {
      label: "10년",
      value: 10,
    },
    {
      label: "7년",
      value: 7,
    },
    {
      label: "5년",
      value: 5,
    },
    {
      label: "3년",
      value: 3,
    },
    {
      label: "2년",
      value: 2,
    },
    {
      label: "1년",
      value: 1,
    },
  ],
};

export const AptToOptions = {
  default: -10,
  options: [
    {
      label: "40년",
      value: 40,
    },
    {
      label: "30년",
      value: 30,
    },
    {
      label: "20년",
      value: 20,
    },
    {
      label: "15년",
      value: 15,
    },
    {
      label: "10년",
      value: 10,
    },
    {
      label: "7년",
      value: 7,
    },
    {
      label: "5년",
      value: 5,
    },
    {
      label: "3년",
      value: 3,
    },
    {
      label: "2년",
      value: 2,
    },
    {
      label: "1년",
      value: 1,
    },
    {
      label: "현재",
      value: -10,
    },
  ],
};

export const AptSortOptions = {
  default: "priceavr",
  options: [
    {
      label: "평단가",
      value: "priceavr",
    },
    {
      label: "시세",
      value: "price",
    },
  ],
  getOption: (value) => {
    if (value === "priceavr") {
      return {
        sort: AptSortKeys.DEAL_PRICE_PER_SPACE_AVR,
        label: "평단가",
        property: "dealPricePerSpaceAvr",
        lease: "leasePricePerSpaceAvr",
      };
    } else if (value === "price") {
      return {
        sort: AptSortKeys.DEAL_PRICE_AVR,
        label: "시세",
        property: "dealPriceAvr",
        lease: "leasePriceAvr",
      };
    }
  },
};

export const AptPyeongTypeOptions = {
  default: DataRanges.APT,
  options: [
    {
      label: "아파트",
      value: DataRanges.APT,
    },
    {
      label: "평기준",
      value: DataRanges.MPYEONG,
    },
  ],
};

export const PyeongTypeOptions = {
  default: PyeongType.SPYEONG,
  options: [
    {
      label: "평형",
      value: PyeongType.SPYEONG,
    },
    {
      label: "전용면적",
      value: PyeongType.EPYEONG,
    },
  ],
};

export const SmallCountPerRegionOptions = {
  default: -1,
  options: [
    {
      label: "전체",
      value: -1,
    },
    {
      label: "1개",
      value: 1,
    },
    {
      label: "2개",
      value: 2,
    },
    {
      label: "3개",
      value: 3,
    },
  ],
};

export const CountPerRegionOptions = {
  default: -1,
  options: [
    {
      label: "전체",
      value: -1,
    },
    {
      label: "1개",
      value: 1,
    },
    {
      label: "3개",
      value: 3,
    },
    {
      label: "5개",
      value: 5,
    },
    {
      label: "10개",
      value: 10,
    },
    {
      label: "20개",
      value: 20,
    },
  ],
};

export const AptHouseholdFromOptions = {
  default: 100,
  options: [
    {
      label: "2000세대",
      value: 2000,
    },
    {
      label: "1500세대",
      value: 1500,
    },
    {
      label: "1000세대",
      value: 1000,
    },
    {
      label: "700세대",
      value: 700,
    },
    {
      label: "500세대",
      value: 500,
    },
    {
      label: "300세대",
      value: 300,
    },
    {
      label: "200세대",
      value: 200,
    },
    {
      label: "100세대",
      value: 100,
    },
  ],
};

export const AptHouseholdToOptions = {
  default: 100000,
  options: [
    {
      label: "전체",
      value: 100000,
    },
    {
      label: "2000세대",
      value: 2000,
    },
    {
      label: "1500세대",
      value: 1500,
    },
    {
      label: "1000세대",
      value: 1000,
    },
    {
      label: "700세대",
      value: 700,
    },
    {
      label: "500세대",
      value: 500,
    },
    {
      label: "300세대",
      value: 300,
    },
    {
      label: "200세대",
      value: 200,
    },
    {
      label: "100세대",
      value: 100,
    },
  ],
};

export const AptRankFromOptions = {
  default: 0,
  options: [
    {
      label: "전체",
      value: 0,
    },
    {
      label: "150위",
      value: 150,
    },
    {
      label: "100위",
      value: 100,
    },
    {
      label: "70위",
      value: 70,
    },
    {
      label: "50위",
      value: 50,
    },
    {
      label: "30위",
      value: 30,
    },
    {
      label: "20위",
      value: 20,
    },
    {
      label: "10위",
      value: 10,
    },
  ],
};

export const AptRankToOptions = {
  default: 100000,
  options: [
    {
      label: "전체",
      value: 100000,
    },

    {
      label: "150위",
      value: 150,
    },
    {
      label: "100위",
      value: 100,
    },
    {
      label: "70위",
      value: 70,
    },
    {
      label: "50위",
      value: 50,
    },
    {
      label: "30위",
      value: 30,
    },
    {
      label: "20위",
      value: 20,
    },
    {
      label: "10위",
      value: 10,
    },
  ],
};

export const YSortOptions = {
  default: getMonthInLong(480),
  options: [
    {
      label: "40년",
      value: getMonthInLong(480),
    },
    {
      label: "30년",
      value: getMonthInLong(360),
    },
    {
      label: "25년",
      value: getMonthInLong(300),
    },
    {
      label: "20년",
      value: getMonthInLong(240),
    },
    {
      label: "15년",
      value: getMonthInLong(180),
    },
    {
      label: "10년",
      value: getMonthInLong(120),
    },
    {
      label: "7년",
      value: getMonthInLong(84),
    },
    {
      label: "5년",
      value: getMonthInLong(60),
    },
    {
      label: "3년",
      value: getMonthInLong(36),
    },
    {
      label: "2년",
      value: getMonthInLong(24),
    },
    {
      label: "1년",
      value: getMonthInLong(12),
    },
  ],
};

export const MSortOptions = {
  default: getMonthInLong(120),
  options: [
    {
      label: "10년",
      value: getMonthInLong(120),
    },
    {
      label: "7년",
      value: getMonthInLong(84),
    },
    {
      label: "5년",
      value: getMonthInLong(60),
    },
    {
      label: "3년",
      value: getMonthInLong(36),
    },
    {
      label: "2년",
      value: getMonthInLong(24),
    },
    {
      label: "1년",
      value: getMonthInLong(12),
    },
    {
      label: "6개월",
      value: getMonthInLong(6),
    },
    {
      label: "3개월",
      value: getMonthInLong(3),
    },
    {
      label: "1개월",
      value: getMonthInLong(1),
    },
  ],
};

export const WSortOptions = {
  default: getWeekInLong(1),
  options: [
    {
      label: "3년",
      value: getMonthInLong(36),
    },
    {
      label: "2년",
      value: getMonthInLong(24),
    },
    {
      label: "1년",
      value: getMonthInLong(12),
    },
    {
      label: "6개월",
      value: getMonthInLong(6),
    },
    {
      label: "3개월",
      value: getMonthInLong(3),
    },
    {
      label: "1개월",
      value: getMonthInLong(1),
    },
    {
      label: "3주",
      value: getWeekInLong(3),
    },
    {
      label: "2주",
      value: getWeekInLong(2),
    },
    {
      label: "1주",
      value: getWeekInLong(1),
    },
  ],
};

/**
 * 단위 규칙
 * - DealPrice / Gap        : 1 = 1만원
 * - DealPricePerSpace      : 1 = 1만원 / 평
 * - LeasePriceRatio        : %
 */

// =========================
// Deal Price (거래가)
// =========================

export const DealPriceFromOptions = {
  default: 0,
  options: [
    { label: "전체", value: 0 },

    { label: "3천만", value: 3000 },
    { label: "5천만", value: 5000 },
    { label: "1억", value: 10000 },
    { label: "2억", value: 20000 },
    { label: "3억", value: 30000 },
    { label: "5억", value: 50000 },
    { label: "7억", value: 70000 },
    { label: "10억", value: 100000 },
    { label: "15억", value: 150000 },
    { label: "20억", value: 200000 },
    { label: "30억", value: 300000 },
    { label: "50억", value: 500000 },
    { label: "100억 이상", value: 1000000 },
  ],
};

export const DealPriceToOptions = {
  default: 5000000, // 5000억
  options: [
    { label: "전체", value: 5000000 },

    { label: "100억", value: 1000000 },
    { label: "50억", value: 500000 },
    { label: "30억", value: 300000 },
    { label: "20억", value: 200000 },
    { label: "15억", value: 150000 },
    { label: "10억", value: 100000 },
    { label: "7억", value: 70000 },
    { label: "5억", value: 50000 },
    { label: "3억", value: 30000 },
    { label: "2억", value: 20000 },
    { label: "1억", value: 10000 },
    { label: "5천만", value: 5000 },
    { label: "3천만", value: 3000 },
  ],
};

// =========================
// Deal Price Per Space (평당가)
// =========================

export const DealPricePerSpaceFromOptions = {
  default: 0,
  options: [
    { label: "전체", value: 0 },

    { label: "300만", value: 300 },
    { label: "500만", value: 500 },
    { label: "700만", value: 700 },
    { label: "1천만", value: 1000 },
    { label: "2천만", value: 2000 },
    { label: "3천만", value: 3000 },
    { label: "4천만", value: 4000 },
    { label: "5천만", value: 5000 },
    { label: "6천만", value: 6000 },
    { label: "7천만", value: 7000 },
    { label: "8천만", value: 8000 },
    { label: "9천만", value: 9000 },
    { label: "1억", value: 10000 },
    { label: "1억5천", value: 15000 },
    { label: "2억", value: 20000 },
    { label: "3억 이상", value: 30000 },
  ],
};

export const DealPricePerSpaceToOptions = {
  default: 1000000,
  options: [
    { label: "전체", value: 1000000 },

    { label: "3억", value: 30000 },
    { label: "2억", value: 20000 },
    { label: "1억5천", value: 15000 },
    { label: "1억", value: 10000 },
    { label: "9천만", value: 9000 },
    { label: "8천만", value: 8000 },
    { label: "7천만", value: 7000 },
    { label: "6천만", value: 6000 },
    { label: "5천만", value: 5000 },
    { label: "4천만", value: 4000 },
    { label: "3천만", value: 3000 },
    { label: "2천만", value: 2000 },
    { label: "1천만", value: 1000 },
    { label: "700만", value: 700 },
    { label: "500만", value: 500 },
    { label: "300만", value: 300 },
  ],
};

// =========================
// Lease Price Ratio (전세가율)
// =========================

export const LeasePriceRatioFromOptions = {
  default: 0,
  options: [
    { label: "전체", value: 0 },
    { label: "10%", value: 10 },
    { label: "20%", value: 20 },
    { label: "30%", value: 30 },
    { label: "40%", value: 40 },
    { label: "50%", value: 50 },
    { label: "60%", value: 60 },
    { label: "70%", value: 70 },
    { label: "80%", value: 80 },
    { label: "90% 이상", value: 90 },
  ],
};

export const LeasePriceRatioToOptions = {
  default: 100,
  options: [
    { label: "전체", value: 100 },

    { label: "90%", value: 90 },
    { label: "80%", value: 80 },
    { label: "70%", value: 70 },
    { label: "60%", value: 60 },
    { label: "50%", value: 50 },
    { label: "40%", value: 40 },
    { label: "30%", value: 30 },
    { label: "20%", value: 20 },
    { label: "10%", value: 10 },
  ],
};

// =========================
// Gap (매매가 - 전세가)
// =========================

export const GapFromOptions = {
  default: 0,
  options: [
    { label: "전체", value: 0 },

    { label: "3천만", value: 3000 },
    { label: "5천만", value: 5000 },
    { label: "1억", value: 10000 },
    { label: "2억", value: 20000 },
    { label: "3억", value: 30000 },
    { label: "5억", value: 50000 },
    { label: "7억", value: 70000 },
    { label: "10억", value: 100000 },
    { label: "15억", value: 150000 },
    { label: "20억", value: 200000 },
    { label: "30억", value: 300000 },
    { label: "50억 이상", value: 500000 },
  ],
};

export const GapToOptions = {
  default: 10000000,
  options: [
    { label: "전체", value: 10000000 },

    { label: "50억", value: 500000 },
    { label: "30억", value: 300000 },
    { label: "20억", value: 200000 },
    { label: "15억", value: 150000 },
    { label: "10억", value: 100000 },
    { label: "7억", value: 70000 },
    { label: "5억", value: 50000 },
    { label: "3억", value: 30000 },
    { label: "2억", value: 20000 },
    { label: "1억", value: 10000 },
    { label: "5천만", value: 5000 },
    { label: "3천만", value: 3000 },
  ],
};

export const ShareScopeOptions = {
  default: "PRIVATE",
  options: [
    {
      label: "비공개",
      value: "PRIVATE",
    },
    {
      label: "공개",
      value: "PUBLIC",
    },
  ],
};
